import { QuoteBindingSearchResponse } from '@lio/api-types';
import { quoteBindingQueryKey } from '@services/quotes/quoteBinding/keys';
import { useQueries } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

const config = {
  staleTime: 60000,
};

export const useSearchQuoteBindingsForQuotes = (quoteIds: string[]) => {
  const client = useClient();
  const result = useQueries({
    queries: quoteIds?.map((quoteId) => ({
      queryKey: quoteBindingQueryKey.searchWithParams(quoteId),
      queryFn: () => client.get(`quote/${quoteId}/binding`).json<QuoteBindingSearchResponse>(),
      ...config,
      enabled: !!quoteId,
    })),
    combine: (result) => {
      const data = result?.map((r) => r.data);
      const isLoading = result?.some((d) => d.isLoading);

      const quoteBindings = !isLoading
        ? data
            ?.filter((d) => !!d && d.items?.length)
            ?.map((d) => ({
              status: d?.items[0].status,
              quoteId: d?.items[0].quoteId,
              id: d?.items[0].id,
              policyNumber: d?.items[0]?.quote?.policyNumber?.policyNumber,
              termPremium: d?.items[0]?.quote?.termPremium,
              termTaxFeeSurcharge: d?.items[0]?.quote?.termTaxFeeSurcharge ?? 0,
            }))
        : [];
      return { quoteBindings, isLoading };
    },
  });

  return result;
};
